

























import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'
@Component({
  name: 'BarNorm',
  components: { Chart, ChartHeader }
})
export default class extends Vue {
  @Prop({ default: '#FFA100' }) private color!: string;
  @Prop({}) private dataList!: any;
  // 超过多少个开始滚动
  @Prop({ default: null }) private scrollNumber!: number | null;
  // 单个数据增加的滚动内容宽度 px
  @Prop({ default: 0 }) private scrollItemWidth!: number;
  private valLength: number = 0;
  private legend: any[] = [
    { name: '参考标准', color: '#666666' },
    { name: '均分', color: this.color }
  ];
  private chartId: string = '';
  private option: any = {
    // animation: false,
    grid: {
      top: 20,
      right: 10,
      left: 30,
      bottom: 70
    },
    // title: {
    //   subtext: '占比（%）'
    // },
    xAxis: [
      {
        type: 'category',
        data: [],
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          interval: 0
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#999999'
        }
      }
    ],
    series: [
      {
        name: '均分',
        type: 'bar',
        data: [],
        label: {},
        itemStyle: {
          color: this.color,
          barBorderRadius: 8
        },
        barWidth: 8,
        markLine: {
          itemStyle: {
            color: '#aeaeae'
          },
          label: {
            show: false,
            position: 'start'
          },
          symbol: ['none', 'none'],
          lineStyle: {
            width: 1
          },
          data: [
            {
              name: '0',
              yAxis: 60
            }
          ]
        }
      }
    ]
  };
  get chart() {
    return this.$refs.chart as any
  }
  @Watch('dataList', { immediate: true, deep: true })
  onDataChange(val: any) {
    if (!this.dataList.length) return

    if (this.dataList.length >= 6) {
      // console.log('设置DataZoom')
      this.option.dataZoom = [
        {
          left: 60,
          right: 60,
          bottom: 15,
          type: 'slider',
          startValue: 0,
          endValue: 5,
          backgroundColor: '#fff',
          fillerColor: '#eee',
          dataBackground: {
            lineStyle: {
              color: '#fff'
            },
            areaStyle: {
              color: '#fff'
            }
          }
        }
      ]
    } else {
      // console.log('取消DataZoom')
      this.option.dataZoom = null
    }
    let names = []
    let data = []
    this.dataList.map((item: any) => {
      names.push(item.name)
      data.push(item.values[0])
    })
    this.valLength = data.length
    this.option.xAxis[0].data = names
    this.option.series[0].data = data
    this.option.series[0].markLine.data[0].yAxis = this.dataList[0].values[1]
    this.$nextTick(() => {
      this.chart.setOption(this.option)
    })
  }
  created() {
    this.chartId =
      new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
}
